// API resources
import apiPortfolioBuilder from '@/api/modules/portfolio-builder'

// Mutations
import {
  RESET_MODULE,
  ADD_PRODUCTS_PORTFOLIO_BUILDER_LIST,
  ADD_PRODUCT_PORTFOLIO_BUILDER_SELECT,
  UPDATE_PRODUCTS_PORTFOLIO_BUILDER_META
} from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    list: [],
    filters: {},
    productSelected: {},
    meta: {},
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  resetState (context) {
    context.commit(RESET_MODULE)
  },

  fetchProductsPortfolioBuilder ({ state, commit }, { filters, page, cached = false }) {
    return apiPortfolioBuilder.fetchProductsPortfolioBuilder(filters, page)
      .then(data => {
        commit(ADD_PRODUCTS_PORTFOLIO_BUILDER_LIST, data.bankContracts)
        commit(UPDATE_PRODUCTS_PORTFOLIO_BUILDER_META, data.meta)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  fetchProductPortfolioBuilder ({ state, commit }, { productId, advisorDetails = true, cached = false }) {
    return apiPortfolioBuilder.fetchProductPortfolioBuilder(productId, advisorDetails)
      .then(data => {
        commit(ADD_PRODUCT_PORTFOLIO_BUILDER_SELECT, data)
        return data
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

const mutations = {
  [ADD_PRODUCT_PORTFOLIO_BUILDER_SELECT] (state, data) {
    state.productSelected = data
  },

  [ADD_PRODUCTS_PORTFOLIO_BUILDER_LIST] (state, data) {
    state.list = data
  },

  [UPDATE_PRODUCTS_PORTFOLIO_BUILDER_META] (state, data) {
    state.meta = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
